<template>
    <x-page title="Edit Template Statistik">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <group-statistic-template-form id="group-statistic-template-form"
            v-if="Boolean(resource)"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="resource" />
        <template #footer>
            <x-submit-button form="group-statistic-template-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { handleGeneralXhrError, handleValidationXhrError } from '../../helpers'
import GroupStatisticTemplateForm from './GroupStatisticTemplateForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        GroupStatisticTemplateForm,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/group-statistic-templates/${this.$route.params.id}`)
                .then(response => {
                    const resources = response.data.data
                    this.resource = { ...resources }
                })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.put(`/api/group-statistic-templates/${this.$route.params.id}`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.label} updated!`,
                    })
                    this.$router.back()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
                this.isLoading = false
            })
        },
    },
}
</script>